import React, { useState } from 'react';
import clsx from 'clsx';
import Figure from '../molecules/Figure';
import { downloadFile, sizeToString } from '../../lib/apis/file';
import styles from '../../styles/components/molecules/Download.module.scss';

interface DownloadProps {
  className?: string;
  type?: string;
  url: string;
  title?: string;
  name?: string;
  category?: string;
  icon?: string;
  description?: string;
  access?: boolean;
  children?: any;
  size?: any;
  href?: string;
}

const Download = (props: DownloadProps) => {
  const [loading, setLoading] = useState(false);
  const {
    className,
    size,
    title,
    type,
    url,
    name,
    description,
    icon,
    children,
    href,
  } = props;
  const classes = clsx(
    styles.download,
    { [styles.loading]: loading },
    'col-s',
    className
  );

  const download = (r: string) => {
    if (href) {
      window.open(href, '_blank');
      return;
    }
    setLoading(true);
    downloadFile(r)
      .then(() => {})
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Figure
      className={classes}
      tiny
      icon={icon || 'document'}
      href={href || `https://uploads.venuescout.org/${url}`}
      disabled
      onClick={async (e) => {
        e.stopPropagation();
        download(url);
      }}
      title={title || name}
      caption={
        <>
          <span>
            {description || ''}
            {type && (
              <>
                <br />
                {`${type.toUpperCase()}`}
                {!!size && <small>{` (${sizeToString(size)})`}</small>}
              </>
            )}
          </span>

          {children}
        </>
      }
    />
  );
};

export default Download;
